export const customEn = {
  StepsTitle: 'Meet Over 70 Singles Near You Today'
};
export const customEs = {
  StepsTitle: 'Conoce solteros mayores de 70 años cerca de ti hoy'
};
export const customDa = {
  StepsTitle: 'Mød singler over 70 nær dig i dag'
};
export const customDe = {
  StepsTitle: 'Triff heute Singles über 70 in deiner Nähe'
};
export const customFi = {
  StepsTitle: 'Tapaa yli 70-vuotiaita sinkkuja lähelläsi tänään'
};
export const customSv = {
  StepsTitle: 'Möt singlar över 70 nära dig idag'
};
export const customFr = {
  StepsTitle: 'Rencontrez des célibataires de plus de 70 ans près de chez vous aujourd’hui'
};
export const customHu = {
  StepsTitle: 'Találkozz 70 feletti szinglikkel a közeledben még ma!'
};
